import React, { memo, useCallback } from 'react'
import { StyledCalendarHeader, StyledWeekdays, StyledCalendarRow, StyledCalendarCell, StyledWeekday } from './styled'
import moment from 'moment'
import { MiniArrowCalendar, BigArrowCalendar } from 'media/icons'
import { getWeekdays, getDaysArray, getValidDateNumber } from './helpers'
import { useWindowSize } from 'hooks/useWindowSize'

const dateFormat = 'MMM YYYY'

const CalendarHeader = (props) => {
	const {
		setMonth = () => { },
		setYear = () => { },
		handleMonthPrev,
		handleMonthNext,
		month,
		year,
		//date,
		hideControls = false
	} = props

	const validMonth = getValidDateNumber(month)
	const formatedDate = moment(
		`${year}-${validMonth}`
	).format(dateFormat)
	//const isNowDate = moment(date).format(pickerDateFormat) === moment(new Date()).format(pickerDateFormat)
	const setPrevMonth = useCallback(() => {
		if (handleMonthPrev) {
			return handleMonthPrev()
		}
		setMonth(prevMonth => {
			const lastMonth = prevMonth === 1
			if (lastMonth) {
				setYear(prevYear => prevYear - 1)
			}
			return lastMonth ? 12 : prevMonth - 1
		})
	}, [setMonth, setYear])
	const setNextMonth = useCallback(() => {
		if (handleMonthNext) {
			return handleMonthNext()
		}
		setMonth(prevMonth => {
			const lastMonth = prevMonth === 12
			if (lastMonth) {
				setYear(prevYear => prevYear + 1)
			}
			return lastMonth ? 1 : prevMonth + 1
		})
	}, [setMonth, setYear])

	const { width } = useWindowSize()

	const bigCalendarIndicator = (width >= 374) && (width <= 768)

	return (
		<StyledCalendarHeader>
			<div className='calendar__title'>
				{formatedDate}
			</div>
			{!hideControls && <div className='calendar__controls'>
				<div
					className='control calendar__controls__back'
					onClick={setPrevMonth}
				>
					{
						bigCalendarIndicator ? <BigArrowCalendar /> : <MiniArrowCalendar />
					}
				</div>
				<div
					className='control calendar__controls__next'
					onClick={setNextMonth}
				>
					{
						bigCalendarIndicator ? <BigArrowCalendar /> : <MiniArrowCalendar />
					}
				</div>
			</div>}
		</StyledCalendarHeader>
	)
}

const CalendarWeekdays = () => {
	const weekdays = getWeekdays()
	return (
		<StyledWeekdays>
			{weekdays.map((day, index) => {
				return (
					<div key={`${day}${index + 1}`}>
						<StyledWeekday day={index + 1}>
							{`${day[0]}${day[1]}` || ''}
						</StyledWeekday>
					</div>
				)
			})}
		</StyledWeekdays>
	)
}

const CalendarBodyCell = memo(props => (
	<StyledCalendarCell {...props}>
		<span>
			{props.children}
		</span>
	</StyledCalendarCell>
))

const CalendarBody = ({
	cells = [],
	currentDate,
	month,
	year,
	handleDateChange,
	changeKey
}) => {
	const date = moment(currentDate)
	const isCurrentMonth = month === (date.month() + 1) && year === date.year()
	return (
		<>
			{cells.map((row, rowIdx) => {
				return (
					<StyledCalendarRow key={`row${rowIdx}`}>
						{row.map((cell, idx) => {
							const isActive = isCurrentMonth && cell.value === date.date() && !cell.blank
							const handlers = !cell.blank
								? { onClick: handleDateChange({ year, month, day: cell.value }, changeKey) }
								: {}
							const holiday = !((idx + 1) % 7) || !((idx + 1) % 6)
							// choose color for day (based by work or holiday)
							// this or next (previous) month
							// and choosen or not this day now
							let textColor = '#434343'
							if(isActive) {
								textColor = '#434343'
							}else if(!cell.blank && holiday) {
								textColor = '#F2874F'
							}else if(!cell.blank && !holiday) {
								textColor = '#434343'
							}else if(cell.blank && holiday) {
								textColor = '#FBBA97'
							}else if(cell.blank && !holiday) {
								textColor = '#CDCDCD'
							}
							return (
								<CalendarBodyCell
									key={`cell${cell.value}`}
									{...cell}
									{...handlers}
									isActive={isActive}
									textColor={textColor}
								>
									{cell.value}
								</CalendarBodyCell>
							)
						})}
					</StyledCalendarRow>
				)
			})}
		</>
	)
}

const Calendar = (props) => {
	const {
		className,
		currentDate,
		month,
		year,
		handleDateChange = () => { },
		changeKey
	} = props
	const cells = getDaysArray(
		year,
		month
	)
	const bodyProps = {
		currentDate,
		cells,
		month,
		year,
		handleDateChange,
		changeKey
	}
	const headerProps = { date: currentDate, ...props }
	return (
		<div className={`${className} calendarShown`}>
			<CalendarHeader {...headerProps} />
			<CalendarWeekdays />
			<CalendarBody {...bodyProps} />
		</div>
	)
}

export default Calendar
